<template>
    <div>
        <router-view />
    </div>
</template>

<script>
import Main from './sites/Main.vue'

export default {
    name: 'App',
    components: {
        Main
    }
}
</script>

<style>

:root {
  --link_color: #42b983;
  --white: #ffffff;
  --left: #fffcf6;
  --btn_hover: #d8ef9b;
  --topbar_blue: #95c11f;
  --babyblue: #cce1e2;
  --topbar_gray: #454545;
  --text: #222222;
}

body {
    background-color: #f7f7f7;
    margin: 0;
    overflow-y: hidden;
    overflow-x: hidden;
}

@font-face {
  font-family: "Lato";
  src: url('../src/assets/fonts/Lato-Regular.ttf');
}

#app {
    font-family: Lato;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin-top: 5vh;
}

textarea {
    font-family: Lato;
}

button {
    font-family: Lato;
    background-color: white;
    border: 1px solid black;
    min-height: 32px;
    padding-left: 60px;
    padding-right: 60px;
    border-radius: 25px;
}

button:focus, button:hover{
    outline:none;
    background-color: #d8ef9b;
}

.bold {
    font-weight: bold;
}

.visible {
    visibility: visible;
}

.hidden {
    visibility: hidden;
}

.fadeIn {
    animation: fadeInAnimation ease 200ms;
    animation-iteration-count: 1;
    animation-fill-mode: forwards;
}

/* Scrollin asetukset */
/* leveys */
::-webkit-scrollbar {
  width: 0.5vw;
}

/* Tausta */
::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Kahva */
::-webkit-scrollbar-thumb {
  background: #888;
   border-radius: 0.4vw;
}

/* Kahvan hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}

@keyframes fadeInAnimation {
    0% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
}

.fadeOut {
    animation: fadeOutAnimation ease 200ms;
    animation-iteration-count: 1;
    animation-fill-mode: forwards;
}

@keyframes fadeOutAnimation {
    0% {
        opacity: 1;
    }
    100% {
        opacity: 0;
    }
}
</style>
